import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { DISPLAY_STATUS, STATUS_OBJECT } from 'src/app/dummy/status';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { PrintService } from 'src/app/services/print.service';
import { TABS } from 'src/app/dummy/tab';
import { APPS, COLLECTION_NAME } from 'src/app/dummy/app';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ResourceStore } from 'src/app/stores/resources/resource.store';
import { IModule } from 'src/app/interfaces/resource';
import { DeleteComponent } from 'src/app/components/delete/delete.component';
import { MatDialog, MatSnackBar } from '@angular/material';
import { DataService } from 'src/app/services/data.service';
import { orderBy } from 'src/app/services/mapping.service';

@Component({
  selector: 'app-training-module',
  templateUrl: './training-module.component.html',
  styleUrls: ['./training-module.component.scss']
})
export class TrainingModuleComponent implements OnInit {
  @ViewChild('PRINT_TABLE', {static:false}) PRINT_TABLE: ElementRef;
  displayStatus = DISPLAY_STATUS
  tabs = TABS.MODULE;
  page: any;
  status: any;
  search: any;
  size = APPS.SIZE
  DISPLAY_STATUS_KEY: any;
  searchTextBox = new FormControl(null, []);

  LEVEL_LIST: any[] = [];
  LEVEL_KEY: any = null;
  params:any;

  form:FormGroup;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public store: ResourceStore,
    private auth: AuthStore,
    public ps: PrintService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private ds: DataService,
    private fb:FormBuilder,
  ) { }

  async ngOnInit() {
    this.form=this.fb.group({
      search:[null,[Validators.required]],
    })
    this.LEVEL_LIST = orderBy(await this.store.fetchListArray(COLLECTION_NAME.LEVEL, "name"), 'order');
    this.route.params.subscribe(async (param) => {
      this.params=param;
      const { id } = param;
      this.LEVEL_KEY = id === 'submitted' ? null : id;
      this.DISPLAY_STATUS_KEY = STATUS_OBJECT.submitted;
      const { selectedCompanyKey } = this.auth;
      await this.store.fetchSelectedLevel(this.LEVEL_KEY);
      this.store.fetchData(COLLECTION_NAME.LESSON, this.DISPLAY_STATUS_KEY.key, selectedCompanyKey, null, null, null, null, this.LEVEL_KEY)
    })
  }

  onSearch(f:any){
    if(this.form.valid){
      const {search}=f;
      const { selectedCompanyKey } = this.auth;
      this.store.search(COLLECTION_NAME.LESSON, this.DISPLAY_STATUS_KEY.key, selectedCompanyKey,search, null, null, null, null, this.LEVEL_KEY)
    }
  }

  onLevel(level: any) {
    this.router.navigate([`/modules/${level.key}`])
  }

  ngOnDestroy() {
    const { fetchDataRef } = this.store;
    fetchDataRef && fetchDataRef.unsubscribe();
  }

  onScroll() {
    const { lastVisible } = this.store;
    if (!lastVisible) return;
    const { selectedCompanyKey } = this.auth;
    this.store.fetchMore(COLLECTION_NAME.LESSON, this.DISPLAY_STATUS_KEY.key, selectedCompanyKey, this.LEVEL_KEY)
  }

  createActivity(item: IModule) {
    this.router.navigate([`/modules/activity-type/${item.activityTypeKey}/${item.default_skill}/${item.key}/draft`])
  }

  showActivity(item: IModule) {
    this.router.navigate([`/modules/submitted/${item.key}/lesson`],{queryParams:this.params})
  }

  create() {
    this.router.navigate([`/modules/module-form/draft`])
  }

  delete(item) {
    const dialogRef = this.dialog.open(DeleteComponent, {
      data: { button: 'delete', name: item.name, title: 'Delete Module' },
      panelClass: 'cs-overlay-panel',
      width: '35vw',
      height: '',
      role: 'dialog',
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'yes') {
        this.store.deleteModule(item, (success, res) => {
          this.snackBar.open("Module has been deleted successful.", "Done", { duration: 1000 });
        })
      }
    })
  }

}
